import React from 'react';
import './GTFSDetails.css';
import FichaTecnica from './FichaTecnica';
/* import iconoDocu from '../assets/icons/archivo.png'; */
/* import { useTranslation } from 'react-i18next'; */

const GTFSDetails = ({ navigate }) => {

 /*  const [language, setLanguage] = useState()

useEffect(() => {
  const lang = localStorage.getItem('language') || 'es';
  if(lang === 'cat') {
    setLanguage('Català')
  } else if (lang === 'en'){
    setLanguage('English')
  } else {
    setLanguage('Español')
  }
}, []) */

 /*  const { t } = useTranslation(); */
  return (
    <div className="gtfs-details">
      {/* <div className='titleAndBack'>
        <p className='title'>{t("staticGTFS.title")}</p>
      </div> */}
      <FichaTecnica/>
      {/* <table className="data-table">
        <thead>
          <tr className='titles'>
            <th className='thFormats'>{t("staticGTFS.tableFormat")}</th>
            <th className='thTipus'>{t("staticGTFS.tableType")}</th>
            <th className='thIdioma'>{t("staticGTFS.tableLanguage")}</th>
            <th className='thEspec'>{t("staticGTFS.tableEspec")}</th>
          </tr>
        </thead>
        <tbody>
          <tr className='trTitles'>
            <td className='backGrey'>
              <div className='pastillaGTFS'>GTFS</div>
            </td>
            <td className='tdImage'>
              <img className='icono' src={iconoDocu} alt="docu" />
            </td>
            <td className='tdSubtitle'>
              
              <span>Català, Español, English</span>
            </td>
            <td>
              <p className='subtitle'>{t("staticGTFS.localitationSubtitle")}</p>
              <li>{t("staticGTFS.locationListOne")}</li>
              <li>{t("staticGTFS.locationListTwo")}</li>
              <li>{t("staticGTFS.locationListThree")}</li>
              <li>{t("staticGTFS.locationListFour")}</li>
              <p className='subtitle'>{t("staticGTFS.viaMetroSubtitle")}</p>
              <li>{t("staticGTFS.viaMetroListOne")}</li>
              <li>{t("staticGTFS.viaMetroListTwo")}</li>
              <li>{t("staticGTFS.viaMetroListThree")}</li>
              <li>{t("staticGTFS.viaMetroListFour")}</li>
              <li>{t("staticGTFS.viaMetroListFive")}</li>
              <p className='subtitle'>{t("staticGTFS.viaBusSubtitle")}</p>
              <li>{t("staticGTFS.viaBusListOne")}</li>
              <li>{t("staticGTFS.viaBusListTwo")}</li>
              <li>{t("staticGTFS.viaBusListThree")}</li>
              <li>{t("staticGTFS.viaBusListFour")}</li>
              <li>{t("staticGTFS.viaBusListFive")}</li>
              <li>{t("staticGTFS.viaBusListSix")}</li>
              <li>{t("staticGTFS.viaBusListSeven")}</li>
             
            </td>
          </tr>
        </tbody>
      </table> */}
    </div>
  );
};

export default GTFSDetails;